<template>
	<div class="main_page contactUs_page">
		<div class="contactUs_box">
			<div v-if="!send_show" class="contactUs_content">
				<p class="contactus">联系我们</p>
				<input class="input" v-model="email" placeholder="您的电子邮箱 / Your email"/>
				<textarea class="input2" placeholder="请输入您的问题"/>
				<el-button round class="send_btn" @click="send_">发送</el-button>
			</div>
			<div v-if="send_show" class="contactUs_content">
				<p class="send_success">发送成功</p>
				<p class="order_number">确认单号：MD053829</p>
				<p class="sorry">我们愿意为您解答任何疑惑。如果我们的产品及服务给您带来任何困扰，我们深表歉意。</p>
				<el-button round class="send_btn" @click="back_home">返回首页</el-button>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
	  name: 'ContactUs',
	  data () {
	    return {
			send_show:false,
			email:''
	    }
	  },
	  created() {
	  		document.documentElement.scrollTop =0
	  },
	  methods:{
		   send_:function(){
			   this.send_show = true
		   },
		   back_home:function(){
			   this.$router.replace("/")
		   }
	  }
	 
	}
</script>

<style scoped="scoped">
	.contactUs_page{
		position: relative;
		background-image: url(https://static.wixstatic.com/media/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.jpg/v1/fill/w_1920,h_823,al_c,q_85,usm_0.66_1.00_0.01/a36401_4635bf0cb41f4f1f9cbf65f56e592e95~mv2_d_7025_3011_s_4_2.webp);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 0 0;
		position: relative;
		width: 100%;
	}
	.contactUs_box{
		padding:80px 0 120px 0;
	}
	.contactUs_content{
		width: 280px;
		min-height: 200px;
		margin:60px auto;
		background-color: rgba(0,0,0,0.5);
		border-radius: 20px;
		padding:40px;
		display: grid;
	}
	.contactUs_content .contactus{
		height: 30px;
		line-height: 30px;
		font-size: 25px;
		color:#FAFAFA;
		text-align: center;
	}
	.contactUs_content .input{
		width: 180px;
		height: 30px;
		line-height: 30px;
		margin-top:40px;
		margin-left:50px;
		font-size: 14px;
		color:#E8E6E6;
		text-align: left;
		background-color: #36373C;
		border-radius:20px;
		border:0;
		text-indent: 10px;
	}
	.contactUs_content .input2{
		width: 100%;
		height: 200px;
		margin-top: 20px;
		line-height: 30px;
		background-color: #36373C;
		border-radius:10px;
		border: 0;
		font-size: 14px;
		color:#E8E6E6;
		text-indent: 10px;
	}
	.contactUs_content .send_btn{
		margin-top:40px;
		width: 80px;
		height: 30px;
		background-color: unset;
		font-size: 12px;
		color: #fff;
		border: 1px #fff solid;
		padding: 0;
		margin-left: 100px;
	}	
	.contactUs_content .send_btn:hover{
		background-color: #fff;
		color:#000;
	}
	.contactUs_content .send_success{
		height: 30px;
		line-height: 30px;
		font-size: 25px;
		color:#FAFAFA;
		text-align: center;
	}
	.contactUs_content .order_number{
		height: 10px;
		line-height: 10px;
		margin-top:10px;
		font-size: 15px;
		color:#FAFAFA;
		text-align: center;
	}
	.contactUs_content .sorry{
		margin-top:30px;
		font-size: 17px;
		color:#FAFAFA;
		text-align: center;
	}	
</style>



// WEBPACK FOOTER //
// src/views/public/ContactUs.vue